import { memo } from "react";
import { t } from "components/CentralDataMangement/translation/Translation";
import NoRecords from "components/common/atoms/NoRecords";
import type { LogSource, Breadcrumb } from "./Interface";
import "./css/logs.css";
import FolderIcon from "static/images/FolderIcon";
import DocumentIcon from "static/images/DocumentIcon";

interface LogFileBrowserProps {
  sources: LogSource[];
  loading: boolean;
  breadcrumbs: Breadcrumb[];
  selectedPath?: string;
  onBreadcrumbClick: (path: string) => void;
  onItemClick: (item: LogSource) => void;
}

const LogFileBrowser = memo(
  ({
    sources,
    loading,
    breadcrumbs,
    selectedPath,
    onBreadcrumbClick,
    onItemClick,
  }: LogFileBrowserProps) => (
    <div className="card h-100">
      <div className="card-body">
        <nav aria-label="breadcrumb">
          <ol className="list-unstyled d-flex align-items-center log-path">
            {breadcrumbs.map((bc: Breadcrumb, index: number) => (
              <>  
                <li
                  key={index}
                  className={`breadcrumb-item d-flex align-items-center ${
                    index === breadcrumbs.length - 1 ? "active" : ""
                  }`}
                >
                  {index === breadcrumbs.length - 1 ? (
                    bc.name
                  ) : (
                    <button
                      className="btn btn-link p-0 text-decoration-none fw-bold"
                      onClick={() => onBreadcrumbClick(bc.path)}
                    >
                      {bc.name}
                    </button>
                  )}
                </li>
                {index < breadcrumbs.length - 1 && (
                  <span className="mx-2">&gt;</span>
                )}
              </>
            ))}
          </ol>
        </nav>
        <div className="table-responsive flex-grow-1">
          <div className="log-file-browser-wrapper scrollBarDesign">
            <table className="table table-hover table-sm">
              <thead>
                <tr className="TableHeader">
                  <th>{t("Name")}</th>
                  <th className="text-end">{t("Last Modified")}</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={2} className="text-center p-5">
                      <div className="spinner-border spinner-border-sm" />
                    </td>
                  </tr>
                ) : sources.length > 0 ? (
                  sources.map((log: LogSource) => (
                    <tr
                      key={log.path}
                      onClick={() => onItemClick(log)}
                      className={`cursor-pointer ${
                        selectedPath === log.path ? "table-active" : ""
                      }`}
                    >
                      <td className="align-middle logs-icon">
                        <span
                          className={`me-2 ${
                            log.type === "folder" ? "text-warning" : "text-info"
                          }`}
                        >
                          {log.type === "folder" ? <FolderIcon /> : <DocumentIcon />}
                        </span>
                        {log.name}
                      </td>
                      <td className="align-middle text-end text-muted small">
                        {new Date(log.last_modified).toLocaleString()}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2}>
                      <NoRecords headerLength={2} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
);

LogFileBrowser.displayName = "LogFileBrowser";

export default LogFileBrowser;